package com.essntl.core.settings.domain.model.feature

data class AllowedFeaturesModel(
    val feature: String,
    val createdAt: String,
)
